import React from 'react'
import styled from 'styled-components'

import { H3 } from 'ds/TextGoat'

export const SectionTitle = styled(H3).attrs(() => ({ as: 'h2' }))`
	${p => p.theme.above('md')`
	margin-bottom: 32px;
  `}

	margin-bottom: 16px;
`

const padding = {
	s: 24,
	m: 48,
}

const width = {
	s: 738,
	m: 936,
}

const verticalPadding = {
	s: 40,
	m: 64,
}

const Outer = styled.section`
	position: relative;
	overflow: hidden;

	/* Fix the ugly selection on Safari */
	/* See: https://stackoverflow.com/questions/62093047/how-to-achieve-clean-text-selection-with-safari */
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	/*  */

	padding: ${p => (p.noTopPadding ? 0 : verticalPadding.s)}px 0 ${p => (p.withBottomBorder ? 0 : verticalPadding.s)}px;
	${p =>
		p.greyBg &&
		`
    background: var(--color-lighterGrey3);
  `}
	${p => p.theme.above('large')`
    padding:
      ${p => (p.noTopPadding ? 0 : verticalPadding.m)}px
      0
      ${p => (p.withBottomBorder ? 0 : verticalPadding.m)}px;
    &:last-of-type:not(footer) {
      padding-bottom: 20px;
    }
  `}
`

const Inner = styled.div`
	width: 100%;
	max-width: ${width.s + padding.s * 2}px;
	margin: 0 auto;
	padding: 0 ${padding.s}px;
	${p => p.theme.above('large')`
    max-width: ${width.m + padding.m * 2}px;
    padding: 0 ${padding.m}px;
  `}
`

const Border = styled.hr`
	width: ${width.s}px;
	margin: ${verticalPadding.s}px auto 0;
	border-bottom: 1px solid var(--color-lightGrey2);
	${p => p.theme.above('large')`
    width: ${width.m}px;
    margin: ${verticalPadding.m}px auto 0;
  `}
`

/* <Section> can be used as a primary wrapper component for site sections,
 * and wraps content in an outer- and inner box to allow full-width backgrounds.
 * With <Section as={...}> prop, it can be used in <Footer> etc. too. */
const Section = ({ children, ...props }) => (
	<Outer {...props}>
		<Inner>{children}</Inner>
		{props.withBottomBorder && <Border />}
	</Outer>
)

export default Section
